import { useState, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import DatePicker, { registerLocale } from 'react-datepicker';
import es from 'date-fns/locale/es';
import ca from 'date-fns/locale/ca';
import fr from 'date-fns/locale/fr';
import de from 'date-fns/locale/de';

const HeroSection = ({ destinos, ruta, lang }) => {
    const { t } = useTranslation();

    var preidioma = ""
    if (lang != 'es') preidioma = lang + "/";

    if (lang == "es")
        registerLocale('es', es)
    else if (lang == "fr")
        registerLocale('fr', fr)
    else if (lang == "ca")
        registerLocale('ca', ca)
    else if (lang == "de")
        registerLocale('de', de)
    else
        registerLocale('es', es)


    const [currentSlide, setCurrentSlide] = useState(0);
    const [dateRange, setDateRange] = useState([null, null]);
    const [startDate, endDate] = dateRange;

    const [cMeses, setCMeses] = useState(2);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 1023);

    const handleResize = () => {
        setIsMobile(window.innerWidth <= 1023);
    };

    const handleFocus = (e) => {
        const { target } = e;

        if (target) {
            target.readOnly = true;  // -------> this for all others
            target.blur(); //  ------> this for ios iphone
        }
    };

    useEffect(() => {
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentSlide((prev) => (prev + 1) % destinos.length);
        }, 5000);
        return () => clearInterval(timer);
    }, []);

    useEffect(() => {
        if (isMobile) {
            setCMeses(1);
        }
        else {
            setCMeses(2);
        }
    }, [isMobile, cMeses]);


    return (

        < section className="cc-swiper-home" >
            <div init="false" pagination="true" navigation="false" className="position-relative c-swiper-home">

                {destinos.map((undestino, index) => (

                    <div role="group" aria-label={`${index}/${destinos.length}`} data-swiper-slide-index={index} className={`carousel position-absolute ${index === currentSlide ? "opacity-100" : "opacity-0"}`} style={{ height: "100%", width: "100%" }} key={index}>
                        {undestino.imagen_principal.length > 0 ?
                            <img src={`${ruta}/destinos/${undestino.id}/${undestino.imagen_principal[0].imagen}`} className="imgcarousel" />
                            :
                            <img src="/images/web/bedloop-nofoto.png" className="imgcarousel" />
                        }
                        <div className="container position-absolute subir-texto">
                            <div className="c-swiper-home_txt">
                                <p className="h1">
                                    {undestino.elnombre}
                                </p>

                                <a tabIndex="0" className="btn btn-outline-white" href={"/" + preidioma + t("buscar") + "?destino=" + undestino.laurl} target="_self"> {t("VER")} </a>
                                <span className="line"></span>
                            </div>
                        </div>
                    </div>
                ))
                }
            </div>
        </ section >

    );
}

export default HeroSection;
